import React from 'react';
import cx from 'classnames';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import { RegisterViewsServices } from '../../../modules/Advertisement/services/AdvertisementService';
import { sendToMessageWhatsApp } from '../../../utils/callToWhatsApp';

interface Props {
  numberPhone: string;
  hasToCall: boolean;
  type: 'big' | 'small';
  text?: string;
  dataValue?: string | any;
  dataValueClassName?: string;
  adId: number;
}
export const CallToNowButton = ({
  numberPhone,
  hasToCall,
  type,
  text,
  dataValue,
  dataValueClassName,
  adId,
}: Props) => {
  const commonStyle = 'white ttu fw6 pointer';
  const className = type === 'big' ? 'f24 mt12' : 'f14-l f12 f16-l mt4 mb12';
  const typeParagraph = hasToCall ? 'Ligar agora' : 'Enviar mensagem';

  const sendToWhatsApp = sendToMessageWhatsApp(numberPhone, text);
  const callNow = `tel:${numberPhone}`;
  const redirectFor = hasToCall ? callNow : sendToWhatsApp;
  const handleOnClick = async () => {
    await RegisterViewsServices.whatsAppCountViews(adId);
    trackCustomEvent({
      action: 'clique',
      category: 'botao',
      label: 'whatsapp',
    });
  };

  return (
    <a
      href={redirectFor}
      className={cx(dataValueClassName, commonStyle, className)}
      target="_blank"
      title={typeParagraph}
      data-value={dataValue}
      onClick={() => {
        handleOnClick();
      }}
      rel="noreferrer"
    >
      {typeParagraph}
    </a>
  );
};
